import Serp from '.';
import '@html/serp/async.scss';
import '@html/serp/uncritical.scss';
import '@html/serp/styles.scss';

if (import.meta.webpackHot) {
  import.meta.webpackHot.addStatusHandler((status) => status === 'apply' && console.clear());
  import.meta.webpackHot.accept();
}

window.addEventListener('load', () => {
  const serp = new Serp();

  serp.initiate();
});
